export class Ingredient {
    constructor(
        public name: string,
        public amount: number
    ) {}
}



// WEBPACK FOOTER //
// C:/gitHub/cookbook/src/app/components/shared/ingredient.model.ts